import { render } from "./SurveyQuestions.vue?vue&type=template&id=54e53009&scoped=true"
import script from "./SurveyQuestions.vue?vue&type=script&lang=js"
export * from "./SurveyQuestions.vue?vue&type=script&lang=js"

import "./SurveyQuestions.vue?vue&type=style&index=0&id=54e53009&scoped=true&lang=css"

import exportComponent from "F:\\omar pos 2\\pos_administration_platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e53009"]])

export default __exports__